// @ts-nocheck
import * as Types from '@instamenu/data-access-stats';

import gql from 'graphql-tag';
import * as Urql from 'urql';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type DailySalesQueryVariables = Types.Exact<{
  restaurantIds: Array<Types.Scalars['ID']['input']> | Types.Scalars['ID']['input'];
  startDate: Types.Scalars['ISO8601Date']['input'];
  endDate: Types.Scalars['ISO8601Date']['input'];
  startTime?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  endTime?: Types.InputMaybe<Types.Scalars['Int']['input']>;
}>;


export type DailySalesQuery = { __typename?: 'Query', stats: { __typename?: 'RestaurantStats', hourlySales: Array<{ __typename?: 'HourlySales', netSales: number, tips: number, hour: number }> } };

export type StatsHourlySalesFieldsFragment = { __typename?: 'RestaurantStats', hourlySales: Array<{ __typename?: 'HourlySales', netSales: number, tips: number, hour: number }> };

export const StatsHourlySalesFieldsFragmentDoc = gql`
    fragment statsHourlySalesFields on RestaurantStats {
  hourlySales {
    netSales
    tips
    hour
  }
}
    `;
export const DailySalesDocument = gql`
    query DailySales($restaurantIds: [ID!]!, $startDate: ISO8601Date!, $endDate: ISO8601Date!, $startTime: Int, $endTime: Int) {
  stats(
    restaurantIds: $restaurantIds
    startTime: $startTime
    endTime: $endTime
    startDate: $startDate
    endDate: $endDate
  ) {
    ...statsHourlySalesFields
  }
}
    ${StatsHourlySalesFieldsFragmentDoc}`;

export function useDailySalesQuery(options: Omit<Urql.UseQueryArgs<DailySalesQueryVariables>, 'query'>) {
  return Urql.useQuery<DailySalesQuery, DailySalesQueryVariables>({ query: DailySalesDocument, ...options });
};